/* --- TON FICHIER STORE.JS ORIGINAL --- */
(function () {
    const STORAGE_KEY = 'midi-express-cart';

    function sanitizeString(value, fallback = '') {
        return typeof value === 'string' && value.trim() ? value.trim() : fallback;
    }

    function slugify(value) {
        return sanitizeString(value, 'item')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function parsePriceValue(value) {
        if (typeof value === 'number' && Number.isFinite(value)) {
            return value;
        }

        const normalized = String(value || '')
            .replace(/eur/gi, '')
            .replace(/[^0-9,.-]/g, '')
            .replace(',', '.');

        const parsed = Number.parseFloat(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    function formatCurrency(value) {
        return `${value.toFixed(2).replace('.', ',')} EUR`;
    }

    function normalizeProduct(rawProduct) {
        const product = rawProduct || {};
        const priceValue = parsePriceValue(product.priceValue ?? product.price);
        const name = sanitizeString(product.name, 'Produit');

        return {
            id: sanitizeString(product.id, slugify(name)),
            name,
            category: sanitizeString(product.category, 'Midi Express'),
            unit: sanitizeString(product.unit, ''),
            image: sanitizeString(product.image, ''),
            price: sanitizeString(product.price, formatCurrency(priceValue)),
            priceValue,
            quantity: Math.max(1, Number.parseInt(product.quantity, 10) || 1)
        };
    }

    function readCart() {
        try {
            const raw = window.localStorage.getItem(STORAGE_KEY);
            const parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed.map(normalizeProduct) : [];
        } catch {
            return [];
        }
    }

    function writeCart(items) {
        const normalized = Array.isArray(items) ? items.map(normalizeProduct) : [];
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
        window.dispatchEvent(new CustomEvent('midi-cart-updated'));
        return normalized;
    }

    function summarizeCart(items) {
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        const totalValue = items.reduce((sum, item) => sum + item.priceValue * item.quantity, 0);
        return {
            count,
            totalValue,
            total: formatCurrency(totalValue)
        };
    }

    function createCartState() {
        return {
            cartOpen: false,
            cartItems: [],
            cart: {
                count: 0,
                totalValue: 0,
                total: '0,00 EUR'
            },
            navItems: ['Fruits et legumes', 'Epicerie salee', 'Epicerie sucree', 'Petit dejeuner', 'Pain et patisserie', 'Bebe', 'Hygiene et beaute', 'Entretien et maison', 'Animaux'],
            initCartState() {
                this.syncCartState();

                if (this._cartListenersReady) {
                    return;
                }

                const sync = () => this.syncCartState();
                window.addEventListener('storage', sync);
                window.addEventListener('midi-cart-updated', sync);
                this._cartListenersReady = true;
            },
            syncCartState() {
                this.cartItems = readCart();
                this.cart = summarizeCart(this.cartItems);
            },
            openCart() {
                this.syncCartState();
                this.cartOpen = true;
            },
            closeCart() {
                this.cartOpen = false;
            },
            addToCart(product, quantity = 1) {
                const normalized = normalizeProduct({ ...product, quantity });
                const items = readCart();
                const existing = items.find((item) => item.id === normalized.id);

                if (existing) {
                    existing.quantity += normalized.quantity;
                } else {
                    items.push(normalized);
                }

                writeCart(items);
                this.syncCartState();
                this.cartOpen = true;
            },
            buyNow(product, quantity = 1) {
                const normalized = normalizeProduct({ ...product, quantity });
                const items = readCart();
                const existing = items.find((item) => item.id === normalized.id);

                if (existing) {
                    existing.quantity += normalized.quantity;
                } else {
                    items.push(normalized);
                }

                writeCart(items);
                this.syncCartState();
                window.location.href = '/cart';
            },
            updateCartQuantity(id, quantity) {
                const items = readCart()
                    .map((item) => {
                        if (item.id !== id) {
                            return item;
                        }

                        return normalizeProduct({ ...item, quantity });
                    })
                    .filter((item) => item.quantity > 0);

                writeCart(items);
                this.syncCartState();
            },
            removeFromCart(id) {
                const items = readCart().filter((item) => item.id !== id);
                writeCart(items);
                this.syncCartState();
            },
            clearCart() {
                writeCart([]);
                this.syncCartState();
            },
            lineTotal(item) {
                return formatCurrency(item.priceValue * item.quantity);
            }
        };
    }

    window.MidiExpressStore = {
        createCartState,
        formatCurrency,
        normalizeProduct,
        parsePriceValue,
        readCart
    };
})();

/* --- TON SCRIPT ALPINE D'ORIGINE --- */
document.addEventListener('alpine:init', () => {
    Alpine.data('storefront', () => {
        return Object.assign({}, window.MidiExpressStore.createCartState(), {
            mobileMenu: false,
            searchOpen: false,
            activeHeroSlide: 0,
            heroInterval: null,
            navItems: ['Fruits et legumes', 'Epicerie salee', 'Epicerie sucree', 'Petit dejeuner', 'Pain et patisserie', 'Bebe', 'Hygiene et beaute', 'Entretien et maison', 'Animaux'],
            heroSlides: [
                { kicker: 'Selection du jour', category: 'Fruits et legumes', name: 'Le marche frais qui donne envie d acheter tout de suite', copy: 'Un hero plein ecran qui fonctionne comme un vrai rayon vedette: produit, prix, cartes secondaires et CTA d achat dans le slide lui-meme.', image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1800&q=80' },
                { kicker: 'Promo cremerie', category: 'Cremerie', name: 'Petit-dejeuner premium, laits, yaourts et essentiels du matin', copy: 'Le carousel peut maintenant pousser une vraie famille produits complete, pas juste une belle image avec un texte a cote.', image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?auto=format&fit=crop&w=1800&q=80' },
                { kicker: 'Boissons & epicerie', category: 'Boissons et epicerie', name: 'Boissons, epicerie et produits stock up pour toute la semaine', copy: 'Chaque slide a maintenant son propre contenu interne avec cartes produits, prix et boutons buy, comme tu l as demande.', image: 'https://images.unsplash.com/photo-1516594798947-e65505dbb29d?auto=format&fit=crop&w=1800&q=80' }
            ],
            trustItems: [
                { icon: '24h', title: 'Livraison rapide', copy: 'Creneaux express et parcours de commande simple.' },
                { icon: 'QC', title: 'Selection soignee', copy: 'Des produits du quotidien avec une vraie hierarchie.' },
                { icon: 'PP', title: 'Paiement securise', copy: 'Un discours e-commerce plus rassurant et plus pro.' },
                { icon: 'CS', title: 'Service client', copy: 'Contact visible et promesse de service claire.' }
            ],
            featuredRayons: [
                { name: 'Fruits et legumes', image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=900&q=80' },
                { name: 'Epicerie salee', image: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?auto=format&fit=crop&w=900&q=80' },
                { name: 'Epicerie sucree', image: 'https://images.unsplash.com/photo-1481391032119-d89fee407e44?auto=format&fit=crop&w=900&q=80' },
                { name: 'Petit dejeuner', image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=900&q=80' },
                { name: 'Pain et patisserie', image: 'https://images.unsplash.com/photo-1517433670267-08bbd4be890f?auto=format&fit=crop&w=900&q=80' },
                { name: 'Bebe', image: 'https://images.unsplash.com/photo-1544126592-807ade215a0b?auto=format&fit=crop&w=900&q=80' },
                { name: 'Hygiene et beaute', image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=900&q=80' },
                { name: 'Entretien et maison', image: 'https://images.unsplash.com/photo-1583947582886-f40ec95dd752?auto=format&fit=crop&w=900&q=80' },
                { name: 'Animaux', image: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&w=900&q=80' }
            ],
            promoProducts: [
                { name: 'Tomates grappes premium', category: 'Fruits et legumes', badge: '-30%', oldPrice: '3,80 EUR', price: '2,66 EUR', copy: 'Une fiche promo heroique avec photo forte, badge clair et action d achat directe.', image: 'https://images.unsplash.com/photo-1592924357228-91a4daadcfea?auto=format&fit=crop&w=900&q=80' },
                { name: 'Lait entier bio ferme locale', category: 'Cremerie', badge: 'BIO', oldPrice: '1,80 EUR', price: '1,45 EUR', copy: 'Un produit simple mais presente comme un vrai best seller du quotidien.', image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?auto=format&fit=crop&w=900&q=80' },
                { name: 'Baguette tradition artisanale', category: 'Boulangerie', badge: 'FRAIS', oldPrice: '1,35 EUR', price: '1,10 EUR', copy: 'Le type de produit qui rend la homepage credible car il parle du quotidien reel.', image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=900&q=80' },
                { name: 'Pack jus orange presse', category: 'Boissons', badge: '-15%', oldPrice: '4,70 EUR', price: '3,99 EUR', copy: 'Un deal boissons pour densifier la promesse marchande des premieres sections.', image: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?auto=format&fit=crop&w=900&q=80' }
            ],
            freshProducts: [
                { name: 'Pommes gala croquantes', category: 'Verger', badge: 'Nouveau', price: '2,40 EUR', unit: 'Le kilo', copy: 'Produit d appel propre avec un ton retail net.', image: 'https://images.unsplash.com/photo-1567306226416-28f0efdc88ce?auto=format&fit=crop&w=900&q=80' },
                { name: 'Avocats prets a deguster', category: 'Fruits frais', badge: 'Selection', price: '3,20 EUR', unit: 'Lot de 2', copy: 'Photo genereuse, information courte et prix visible.', image: 'https://images.unsplash.com/photo-1519162808019-7de1683fa2ad?auto=format&fit=crop&w=900&q=80' },
                { name: 'Carottes nouvelles', category: 'Legumes frais', badge: 'Local', price: '1,95 EUR', unit: 'Botte', copy: 'Une card simple pour garder un rythme de lecture propre.', image: 'https://images.unsplash.com/photo-1447175008436-054170c2e979?auto=format&fit=crop&w=900&q=80' },
                { name: 'Salade jeune pousse', category: 'Salade', badge: 'Ultra frais', price: '1,80 EUR', unit: 'Piece', copy: 'La categorie doit respirer tout en montrant plus de produits.', image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=900&q=80' }
            ],
            pantryProducts: [
                { name: 'Sauce tomate cuisine italienne', category: 'Epicerie salee', badge: 'Best seller', price: '2,10 EUR', unit: 'Bocal 480 g', copy: 'Une mise en page horizontale qui change des cards classiques et rappelle les gros sites marchands.', image: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?auto=format&fit=crop&w=1000&q=80', tags: ['Cuisine', 'Essentiel', 'Famille'] },
                { name: 'Pack eau minerale premium', category: 'Boissons', badge: '6 bouteilles', price: '3,60 EUR', unit: 'Pack', copy: 'Le rayon boisson se lit mieux avec plus d espace, plus d infos utiles et un CTA stable.', image: 'https://images.unsplash.com/photo-1564419320461-6870880221ad?auto=format&fit=crop&w=1000&q=80', tags: ['Hydratation', 'Quotidien', 'Livrable'] },
                { name: 'Pates artisanales penne', category: 'Epicerie', badge: 'Lot malin', price: '4,90 EUR', unit: '3 x 500 g', copy: 'Cette variante de card permet de presenter plus d arguments sans surcharger la grille.', image: 'https://images.unsplash.com/photo-1556761223-4c4282c73f77?auto=format&fit=crop&w=1000&q=80', tags: ['Stock up', 'Cuisine', 'Promo'] },
                { name: 'Jus detox vert maison', category: 'Boissons fraiches', badge: 'Frais', price: '2,85 EUR', unit: '25 cl', copy: 'Un produit plus lifestyle pour donner une sensation 2026 sans tomber dans le template.', image: 'https://images.unsplash.com/photo-1622597467836-f3285f2131b8?auto=format&fit=crop&w=1000&q=80', tags: ['Healthy', 'Express', 'Selection'] }
            ],
            init() {
                this.initCartState();
                this.heroInterval = window.setInterval(() => {
                    this.nextHeroSlide();
                }, 5000);
            },
            nextHeroSlide() {
                this.activeHeroSlide = (this.activeHeroSlide + 1) % this.heroSlides.length;
            },
            prevHeroSlide() {
                this.activeHeroSlide = (this.activeHeroSlide - 1 + this.heroSlides.length) % this.heroSlides.length;
            }
        });
    });
});